import React ,{useEffect} from "react";
import WOW from 'wowjs';
import 'animate.css';
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faSquareWhatsapp,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import twitter from '../Assets/Images/twitterx.svg'
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import {
  faMailBulk,
  faMapMarkerAlt,
  faPhone,
  faLocationDot,

} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../Assets/Images/h-rooms-01.png";
// import footerbg from '../Assets/Images/Footerr-01.png'
import footerbg from "../Assets/Images/footerbg.png";
// import footerbg from '../Assets/Images/mahdiya-aqila-vs9M2P9K328-unsplash.jpg'
import { NavLink } from "react-router-dom";
import moment from "moment";

function Footer() {
   useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);


  return (
    <>
      <footer
        className="text-white py-5 mt-4"
        style={{
          backgroundImage: `url(${footerbg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
          minHeight: "300px",
          zIndex: 1,
        }}
      >
        {/* Overlay - Non-interactive */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgb(255 255 255 / 91%)",
            zIndex: 1,
            pointerEvents: "none", // let clicks pass through
          }}
        ></div>

        {/* Footer Content */}
        <div
          className="container"
          style={{
            position: "relative",
            zIndex: 2, // higher than overlay
          }}
        >
          <div className="row text-dark">
            {/* Column 1 - Logo */}
            <div
              className="col-12 col-md-6 col-lg-4 mb-4"
              style={{ position: "relative", zIndex: 2 }}
            >
              <NavLink to="/">
                <img src={logo} alt="Footer Logo" height='90' width='290' className="img-fluid wow animate__animated animate__slideInLeft" />{" "}
              </NavLink>

              <div className="d-flex ms-4 gap-3">
                <a
                  href="https://wa.me/966509786777" // Correct format: no +, no spaces
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary fs-4"
                >
                  <FontAwesomeIcon className="text-danger" icon={faWhatsapp} />
                </a>

                <a
                  href="https://www.facebook.com/haramaynroom/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary fs-4"
                >
                  <FontAwesomeIcon className="text-danger" icon={faFacebook} />
                </a>
                <a
                  href="https://www.instagram.com/haramaynrooms/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary fs-4"
                >
                  <FontAwesomeIcon className="text-danger" icon={faInstagram} />
                </a>
                <a
                  href="https://x.com/HaramaynRooms1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary fs-4 d-flex"
                >
                  <img src={twitter} style={{height:'25px', marginTop:'6px'}}  alt="Twitter" className="img-fluid text-danger" />
                </a>
                {/* <a
                  // href=""
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary fs-4"
                >
                  <FontAwesomeIcon className="text-danger" icon={faLinkedin} />
                </a> */}
              </div>
            </div>

            {/* Column 2 - Who Are We */}
            <div
              className="col-12 col-md-6 col-lg-3  wow animate__animated animate__fadeInUp"
              style={{ position: "relative", zIndex: 2 }}
            >
              <h4 className="mb-3 fw-bold">Who Are We</h4>
              <p className="fw-bold fs-6">
                Haramayn Rooms – Largest Market Place to Search Hotel Rooms in
                Makkah and Madinah.
              </p>
            </div>

            {/* Column 3 - Website Links */}
            <div
              className="col-12 col-md-6 col-lg-2  wow animate__animated animate__fadeInUp"
              style={{ position: "relative", zIndex: 2 }}
            >
              <h4 className="mb-3">Pages</h4>
              <ul className="list-unstyled page-links">
                <li className="mb-2">
                  <NavLink
                    to="/"
                    className="text-decoration-none  fw-bold fs-6"
                  >
                    Home
                  </NavLink>
                </li>
                <li className="mb-2">
                  <NavLink
                    to="/about_us"
                    className="text-decoration-none  fw-bold fs-6"
                  >
                    About Us
                  </NavLink>
                </li>
                <li className="mb-2">
                  <NavLink
                    to="/contact_us"
                    className="text-decoration-none  fw-bold fs-6"
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Column 4 - Contact */}
            <div
              className="col-12 col-md-6 col-lg-3  wow animate__animated animate__fadeInUp"
              style={{ position: "relative", zIndex: 2 }}
            >
              <h4 className="mb-3">Contact</h4>
              <p className="mb-1">
                <a
                  href="mailto:info@haramaynrooms.com"
                  className="text-decoration-none  fw-bold fs-6"
                >
                  <FontAwesomeIcon
                    className="me-2 fw-bold "
                    icon={faEnvelope}
                  />{" "}
                  info@haramaynrooms.com
                </a>
              </p>

              <p className="mb-1">
                <a
                  href="tel:+966509786777"
                  className="text-decoration-none  fw-bold fs-6"
                >
                  <FontAwesomeIcon className="me-2" icon={faPhone} />
                  966 50 978 6777
                </a>
              </p> 
              <p className="mb-1">
              <a
  href="https://wa.me/966509786777"
  target="_blank"
  rel="noopener noreferrer"
  className="text-decoration-none fw-bold fs-6"
>
  <FontAwesomeIcon className="me-2 fs-5" icon={faWhatsapp} />
  966 50 978 6777
</a>
              </p>
              {/* <p className="mb-1">
                <FontAwesomeIcon className="me-2 " icon={faLocationDot} />
                1a Nansen Road Sparkhill Birmingham B11 4DR UK
              </p> */}
            </div>
          </div>
          <div className="footer-copyrights">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Haramayn Rooms. All rights
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <section className="primary-bg page-nav-container">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-12 col-lg-9">
              <div className="menu-page-menu-container">
              <ul className="page-nav text-center text-md-start">
  <li
    id="menu-item-8754"
    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-8754"
  >
    <NavLink className="text-decoration-none" to="/about_us">
      Who we are
    </NavLink>
  </li>
  <li
    id="menu-item-8758"
    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-8758"
  >
    <NavLink className="text-decoration-none" to="/faqs">
      Faqs
    </NavLink>
  </li>
  <li
    id="menu-item-8759"
    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-8759"
  >
    <NavLink
      className="text-decoration-none"
      to="/terms-and-conditions"
    >
      Terms & Conditions
    </NavLink>
  </li>
</ul>

              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-3">
              <div className="green_nav-sub_header bg-dark">
                <a
                  className="text-decoration-none"
                  href="tel:+966509786777"
                  style={{ color: "#fff" }}
                >
                  {/* <svg
                    className="svg-inline--fa fa-phone fa-w-16"
                    style={{ fontSize: "13px" }}
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fa"
                    data-icon="phone"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                    ></path>
                  </svg>{" "} */}
                  <i className="fa fa-phone" style={{ fontSize: "13px" }}></i>{" "}
                  &nbsp; Call
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a
                  className="text-decoration-none"
                  href="mailto:info@haramaynrooms.com"
                  style={{ color: "#fff" }}
                >
                  {/* <svg
                    className="svg-inline--fa fa-envelope fa-w-16"
                    style={{ fontSize: "13px" }}
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fa"
                    data-icon="envelope"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                    ></path>
                  </svg>{" "} */}
                  <i className="fa fa-envelope" style={{ fontSize: "13px" }}></i>{" "}
                  &nbsp; Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Footer;
